import { defineStore } from 'pinia';
import $api from '@/plugins/axios';

export const useManagerStore = defineStore('ManagerStore', {
  state: () => {
    return {
      list: [],
      maxCount: 10,
      activeCount: 0,
      totalCount: 0,
      observerCount: 0,
      totalPage:0,
      isInfoDisable: false,
      summary: {
        activeManagerCount:0,
        authenticatedManagerCount:0,
        creatableManagerCount:0,
        limitManagerCount:0,
        noneAuthenticatedManagerCount:0
      },
      searchSummary: {
        activeManagerCount:0,
        inactiveManagerCount: 0,
        authenticatedManagerCount:0,
        creatableManagerCount:0,
        noneAuthenticatedManagerCount:0
      },
      managerInfo: null,
      pageInfo: {},
      managerGroupSettingList: [],
      managerAlertInfo: {},
    }
  },
  actions: {
    /** 운영관리자 가입 */
    async postManagers(params) {
      return await $api.post('/customers/managers', params);
    },
    /** 옵저버 고객 카운트 가져오기 */
    async getObserverCount() {
      try {
        const res = await $api.get('/academies/observer-customers/counts');
        this.observerCount = res.data;
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 관리자 요약정보 가져오기 */
    async getManagerSummary(){
      try {
        const res = await $api.get('/customers/managers/summaries', {});
        this.summary = res;
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 관리자 요약정보 가져오기 */
    async getManagerCountSummary(params){
      try {
        const res = await $api.get('/customers/managers/summaries', {params});
        this.searchSummary = res;
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 계정 가능 추가 인원 가져오기 */
    async getActiveManagerCounts(){
      try {
        const res = await $api.get('/academies/active-manager-customers/counts');
        this.activeCount = res.data;
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 운영관리자 검색 */
    async getManagers(params) {
      try {
        const res = await $api.get(`/customers/managers`, {params});
        this.list = res.content;
        this.pageInfo = {
          totalCount: res.total,
          totalPages: Math.ceil(res.total / res.pageable.size)
        }
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 운영관리자 검색 */
    async getManagersForExcel(params) {
      try {
        const res = await $api.get(`/customers/managers`, {params});
        return res.content
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 운영관리자 정보조회 */
    async getManagerInfo(customerId){
      try {
        const res = await $api.get(`/customers/managers/${customerId}`);
        this.managerInfo = res;
        return res
      } catch (e) {
        this.$handleError(e);
      }
    },
    async getCustomerManager(customerId){
      try{
        const { data } = await $api.get(`/customers/managers/manage-groups/students/${customerId}/assigned`);
        return data;
      }catch(e) {
        // console.error(e)
      }
    },
    /** 운영관리자 삭제 */
    async deleteManager(customerId) {
      try {
        await $api.delete(`/customers/managers/${customerId}`)
      } catch(e) {
        this.$handleError(e);
      }
    },
    /** 운영관리자 bulk 삭제 */
    async deleteManagers(customerIds) {
      console.log(customerIds)
      try {
        customerIds.forEach(async (customerId)=> {
          await $api.delete(`/customers/managers/${customerId}`)
        })
      } catch(e) {
        this.$handleError(e);
      }
    },
    /** 운영관리자 활성화 */
    async activateManager(customerId){
      try {
        await $api.post(`/customers/managers/${customerId}/activates`)
      } catch(e) {
        this.$handleError(e);
      }
    },
    /** 운영관리자 bulk 활성화 */
    async activateManagers(customerIds){
      try {
        customerIds.forEach(async (customerId)=> {
          await $api.post(`/customers/managers/${customerId}/activates`)
        })
      } catch(e) {
        this.$handleError(e);
      }
    },
    /** 운영관리자 비활성화 */
    async deactivateManager(customerId){
      try {
        await $api.delete(`/customers/managers/${customerId}/activates`)
      } catch(e) {
        this.$handleError(e);
      }
    },
    /** 운영관리자 권한변경 */
    async patchManagerPermission(params) {
      return await $api.patch(`/customers/managers/${params.customerId}/permissions`, {permissions: params.permissions});
    },
    /** 관리자정보 수정 */
    async patchInfo(params) {
      try {
        await $api.patch(`/customers/managers/${params.customerId}`, params);
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 관리자 알림 권한 조회*/
    async getManagerAlertSetting(customerId) {
      try {
        const data = await $api.get(`/customers/managers/${customerId}/alert-settings`);
        this.managerAlertInfo = data.data
      } catch (e) {
        this.$handleError(e)
      }

    },
    /** 관리자 알림 권한 수정*/
    async patchManagerAlertSetting(params) {
      try {
        await $api.patch(`/customers/managers/${params.customerId}/alert-settings`, params);
      } catch (e) {
        this.$handleError(e);
      }
    },
    async getManagerGroup(params){
      try{
        const res = await $api.get('/customers/managers/manage-groups', {params});
        this.managerGroupSettingList = res.content;
        this.pageInfo = {
          totalCount: res.total,
          totalPages: Math.ceil(res.total / res.pageable.size)
        }
      }catch(e){
        this.$handleError(e);
      }
    },
    async getManagerCount(customerId){
      const { data } = await $api.get(`/customers/managers/${customerId}/students/counts`);
      return data;
    },
    /** 관리 그룹 설정 추가 */
    async assignStudentManagerGroup(customerId, manageStudentList){
      try {
        await $api.patch(`/customers/managers/${customerId}/manage-groups/assign`, {manageStudentList});
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 관리 그룹 설정 삭제 */
    async unAssignStudentManagerGroup(customerId, studentIdList){
      try {
        await $api.patch(`/customers/managers/${customerId}/manage-groups/un-assign`, {studentIdList});
      } catch (e) {
        this.$handleError(e);
      }
    },
    $handleError(e) {
      this.$nuxt.$sentry.captureException(e);
      this.$nuxt.error({ statusCode: e.response.status });
    }
  },
  getters: {
  }
})
